import * as THREE from 'three';

/**
 * Single WebGLRenderer instance for the entire app lifecycle.
 * NEVER destroy or recreate this. One renderer, one canvas, forever.
 */
let renderer: THREE.WebGLRenderer | null = null;

export function createRenderer(): THREE.WebGLRenderer {
  if (renderer) return renderer;

  renderer = new THREE.WebGLRenderer({
    antialias: false,               // Postprocessing handles AA
    powerPreference: 'high-performance',
    stencil: false,
  });

  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;
  renderer.outputColorSpace = THREE.SRGBColorSpace;

  document.body.appendChild(renderer.domElement);

  return renderer;
}

export function getRenderer(): THREE.WebGLRenderer {
  if (!renderer) throw new Error('Renderer not created yet. Call createRenderer() first.');
  return renderer;
}
